import { generatePath, useHistory } from 'react-router-dom';
import { NavMarker } from 'react-rhumb';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useAvailableObjectTypes } from '../crmObjects/hooks/useAvailableObjectTypes';
import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { INVOICE_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { navigateTo } from 'growth-payments-core/urls/utils';
import PortalIdParser from 'PortalIdParser';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UnavailableObjectTypeError = ({
  error,
  objectTypeId
}) => {
  useEffect(() => {
    if (error) {
      Raven.captureException(error);
    }
  }, [error]);
  const history = useHistory();
  const objectTypes = useAvailableObjectTypes();
  const contactsPlural = objectTypes.has('0-1') ? objectTypes.get('0-1').pluralForm : 'contacts';
  if (objectTypeId === INVOICE_TYPE_ID) {
    navigateTo(`/commerce-get-started/${PortalIdParser.get()}/invoices`);
    return /*#__PURE__*/_jsx(LoadingOverlay, {});
  }
  return /*#__PURE__*/_jsxs(ErrorMessage, {
    type: "notFound",
    "data-test-id": 'unavailable-object-type-error',
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "UNAVAILABLE_OBJECT_TYPE"
    }), /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "index.errorBoundaries.unavailableObjectType.objectUnvailableContinueToContacts",
        options: {
          contactsPlural: /*#__PURE__*/_jsx(Button, {
            use: "link",
            onClick: () => history.push(generatePath('/objects/:objectTypeId', {
              objectTypeId: '0-1'
            })),
            children: contactsPlural
          })
        }
      })
    })]
  });
};